import { Link } from "react-router-dom";

const principles = [
  {
    icon: "ri-shield-check-line",
    title: "信源分层",
    desc: "每条内容都标注信源类型，只有单一匿名截图、没有旁证的说法会明确标为待确认。",
  },
  {
    icon: "ri-time-line",
    title: "时间线优先",
    desc: "按时间顺序梳理进展，先讲清楚发生了什么，再谈讨论为什么起来，不做情绪化放大。",
  },
  {
    icon: "ri-refresh-line",
    title: "有误即改",
    desc: "如果某个说法后来被证实有误，会在原页面更新说明，而不是悄悄删掉当作没发生。",
  },
];

const metrics = [
  { value: "8 年", label: "内容整理经验" },
  { value: "每 30 分钟", label: "时间线巡检频率" },
  { value: "96%", label: "读者复访意愿" },
];

export default function BrandSection() {
  return (
    <section className="bg-background-100 py-14 md:py-16">
      <div className="mx-auto grid max-w-shell gap-10 px-4 md:px-6 lg:grid-cols-2 lg:items-center">
        <div>
          <p className="mb-2 flex items-center gap-2 text-xs font-label uppercase tracking-[0.28em] text-primary-600">
            <span className="inline-block h-3 w-0.5 bg-primary-500" />
            About
          </p>
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            我们只做一件事：把瓜讲清楚
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            瓜料动态是一个资讯整理平台，不做独家爆料，也不生产情绪。我们把公开可见的信息按时间排好，把背景补上，让你在几分钟内判断清楚一条消息到底走到了哪一步。
          </p>

          <ul className="mt-7 space-y-4">
            {principles.map((item) => (
              <li key={item.title} className="flex gap-4 rounded-lg border border-background-200 bg-background-50 p-4">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-600">
                  <i className={`${item.icon} text-lg`} />
                </span>
                <span>
                  <span className="block font-heading text-base font-bold text-foreground-950">{item.title}</span>
                  <span className="mt-1 block text-sm leading-relaxed text-foreground-600">{item.desc}</span>
                </span>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <div className="overflow-hidden rounded-lg border border-background-200">
            <div className="h-64 w-full overflow-hidden md:h-80">
              <img
                src="https://readdy.ai/api/search-image?query=warm%20editorial%20desk%20with%20notebook%2C%20coffee%20cup%20and%20soft%20afternoon%20light%20through%20window%2C%20stylized%20clean%20scene%2C%20no%20people%2C%20cream%20and%20amber%20tones&width=1000&height=760&seq=gua-brand-01&orientation=landscape"
                alt="瓜料动态编辑整理工作场景"
                title="瓜料动态 - 内容整理与编辑标准"
                className="h-full w-full object-cover object-top"
              />
            </div>
            <div className="grid grid-cols-3 divide-x divide-background-200 bg-background-50">
              {metrics.map((item) => (
                <div key={item.label} className="p-4 text-center md:p-5">
                  <p className="font-heading text-lg font-bold text-primary-600 md:text-xl">{item.value}</p>
                  <p className="mt-1 text-xs text-foreground-500">{item.label}</p>
                </div>
              ))}
            </div>
          </div>
          <Link
            to="/about"
            className="mt-4 inline-flex items-center gap-1.5 text-sm text-primary-600 transition-colors hover:text-primary-700"
          >
            查看完整的品牌与内容原则 <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}